module.exports = __webpack_public_path__ + "img/cloud-hail-lightning.0fa3c7a8.svg";